import './commons.scss';
import './mediaQueries.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { HashRouter } from 'react-router-dom';

//import registerServiceWorker from './registerServiceWorker';
import { store } from './store';
import { AuthRoute } from './components/reusableComponents/AuthRoute';
import { LoginPage } from './components/LoginPage';
import { HomePage } from './components/HomePage';
import { Inspections } from './components/Inspections/Inspections';
import { DailyForm } from './components/Forms/DailyForm';
import { MonthlySWForm } from './components/Forms/MonthlyForm/MonthlySWForm';
import { MonthlyUSTSpillForm } from './components/Forms/MonthlyForm/MonthlyUSTSpillForm';
import { MonthlyUSTRectifierForm } from './components/Forms/MonthlyForm/MonthlyUSTRectifierForm';
import { MonthlySPCCForm } from './components/Forms/MonthlyForm/MonthlySPCCForm';
import { DailyPMForm } from './components/Forms/DailyForm/PlantPreventive';
import { QTRVisualForm } from './components/Forms/QuarterlyForm/QTRVisualForm';
import { ShopInspectionForm } from './components/Forms/QuarterlyForm/ShopInspectionForm';
import { Maintenance } from './components/Maintenance';
import { TechnicalSupportPage } from './components/TechnicalSupportPage';
import { UpdatePlantForm } from './components/Maintenance/UpdatePlantForm';
import { AddPlantForm } from './components/Maintenance/AddPlantForm';
import { SummaryReportsSlider } from './components/Summary/ListPage/SummaryReportsSlider';
import { UserList } from './components/Users/UserList';
import { UpdatePassword } from './components/Profile/UpdatePassword';
import { DailyReports } from './components/Reports/Daily/DailyReports';
import { Dashboard } from './components/Dashboard';
import { FlaggedFormDetails } from './components/FlaggedForm/FlaggedFormDetails';
import { FlaggedFormList } from './components/FlaggedForm/FlaggedFormList';
import { DailyChecklistReport } from './components/Summary/ReportsPage/DailyChecklistReport';
import { MonthlyChecklistReport } from './components/Summary/ReportsPage/MonthlyChecklistReport';
import { QuarterlyChecklistReport } from './components/Summary/ReportsPage/QuarterlyChecklistReport';
import { MonthlyReports } from './components/Reports/Monthly/MonthlyReports';
import { QuarterlyReports } from './components/Reports/Quarterly/QuarterlyReports';
import { MonthlySpillLogForm } from './components/Forms/MonthlyForm/MonthlySpillLogForm';
import { DetailsPage as PlantDetails } from './components/Maintenance/DetailsPage';
import { Profile } from './components/Profile/index';
import { CreateForm } from './components/Users/CreateForm';
import { UpdateForm } from './components/Users/UpdateForm';
import { DetailsPage as MDetails } from './components/Reports/Monthly/DetailsPage';
import { DetailsPage as QDetails } from './components/Reports/Quarterly/DetailsPage';
import { DetailsPage as DDetails } from './components/Reports/Daily/DetailsPage';
import { DetailsPagePlantPreventive } from './components/Reports/Daily/DetailsPagePlantPreventive'; 
declare var require: any;
require('react-perfect-scrollbar/dist/css/styles.css');
require('react-select/dist/react-select.css'); 
require('font-awesome/css/font-awesome.min.css');

ReactDOM.render(
        <Provider store={store}>
                <HashRouter>
                        <Switch>
                                <Route exact path="/" component={LoginPage} />
                                <AuthRoute exact path="/home" component={HomePage} />
                                <AuthRoute exact path="/inspections" component={Inspections} />
                                <AuthRoute
                                        exact
                                        path="/DailyForm/:date/:plantId"
                                        component={DailyForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/DailyForm/:date/:plantId/:formId"
                                        component={DailyForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/PlantPreventive/:date/:plantId"
                                        component={DailyPMForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/PlantPreventive/:date/:plantId/:formId"
                                        component={DailyPMForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/monthly-checklist-form/MonthlySpillLogs/:date/:plantId/:plantRegion"
                                        component={MonthlySpillLogForm}
                                />
                                <AuthRoute
                                        exact
                                        path=
                                        "/monthly-checklist-form/MonthlySpillLogs/:date/:plantId/:plantRegion/:formId"
                                        component={MonthlySpillLogForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/monthly-checklist-form/MonthlySW/:date/:plantId/:plantRegion"
                                        component={MonthlySWForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/monthly-checklist-form/MonthlySW/:date/:plantId/:plantRegion/:formId"
                                        component={MonthlySWForm}
                                />
                                <AuthRoute
                                        exact
                                        /*tslint:disable-next-line*/
                                        path="/monthly-checklist-form/MonthlyUSTSpill/:date/:plantId/:plantRegion/:followUpAction"
                                        component={MonthlyUSTSpillForm}
                                />
                                <AuthRoute
                                        exact
                                        /*tslint:disable-next-line*/
                                        path="/monthly-checklist-form/MonthlyUSTSpill/:date/:plantId/:plantRegion/:followUpAction/:formId"
                                        component={MonthlyUSTSpillForm}
                                />
                                <AuthRoute
                                        exact
                                        /*tslint:disable-next-line*/
                                        path="/monthly-checklist-form/MonthlyUSTSpill/:date/:plantId/:plantRegion"
                                        component={MonthlyUSTSpillForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/monthly-checklist-form/MonthlyUSTRect/:date/:plantId/:plantRegion"
                                        component={MonthlyUSTRectifierForm}
                                />
                                <AuthRoute
                                        exact
                                        path=
                                        "/monthly-checklist-form/MonthlyUSTRect/:date/:plantId/:plantRegion/:formId"
                                        component={MonthlyUSTRectifierForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/monthly-checklist-form/MonthlySPCC/:date/:plantId/:plantRegion"
                                        component={MonthlySPCCForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/monthly-checklist-form/MonthlySPCC/:date/:plantId/:plantRegion/:formId"
                                        component={MonthlySPCCForm}
                                />

                                <AuthRoute
                                        exact
                                        path="/quarterly-checklist-form/QTRVisual/:date/:outfall/:plantId/:region"
                                        component={QTRVisualForm}
                                />
                                <AuthRoute
                                        exact
                                        path=
                                        "/quarterly-checklist-form/QTRVisual/:date/:outfall/:plantId/:region/:formId"
                                        component={QTRVisualForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/quarterly-checklist-form/ShopInspection/:date/:plantId/:region"
                                        component={ShopInspectionForm}
                                />
                                <AuthRoute
                                        exact
                                        path="/quarterly-checklist-form/ShopInspection/:date/:plantId/:region/:formId"
                                        component={ShopInspectionForm}
                                />
                                <AuthRoute exact path="/maintenance" component={Maintenance} />
                                <AuthRoute exact path="/technical-support" component={TechnicalSupportPage} />
                                <AuthRoute exact path="/maintenance/update/:id" component={UpdatePlantForm} />
                                <AuthRoute exact path="/maintenance/create" component={AddPlantForm} />
                                <AuthRoute exact path="/maintenance/:id/:plantId" component={PlantDetails} />
                                <AuthRoute exact path="/summary-reports" component={SummaryReportsSlider} />
                                <AuthRoute exact path="/user-profile/:id" component={Profile} />
                                <AuthRoute exact path="/user/list" component={UserList} />
                                <AuthRoute exact path="/user/update-password" component={UpdatePassword} />
                                <AuthRoute exact path="/user/create" component={CreateForm} />
                                <AuthRoute exact path="/user/update/:id" component={UpdateForm} />
                                <Route exact path="/reports/daily" component={DailyReports} />
                                <AuthRoute exact path="/dashboard" component={Dashboard} />
                                <AuthRoute exact path="/reports/daily/:id/:region/:plantId/:date/:username"
                                component={DDetails} />
                                <AuthRoute exact path="/reports/PlantPreventive/:id/:region/:plantId/:date/:username"
                                component={DetailsPagePlantPreventive} />

                                <AuthRoute
                                        exact
                                        path="/flagged-forms/:category/:id"
                                        component={FlaggedFormDetails} />
                                <AuthRoute
                                        exact
                                        path="/flagged-forms" component={FlaggedFormList} />
                                <Route
                                        exact
                                        path="/summary-reports/:formType/:plantId/:date/:id"
                                        component={DailyChecklistReport} />

                                <Route
                                        exact
                                        path="/summary-reports/monthly/:formType/:plantId/:date/:id"
                                        component={MonthlyChecklistReport} />
                                <Route
                                        exact
                                        path="/summary-reports/quarterly/:formType/:plantId/:date/:id/:outfall"
                                        component={QuarterlyChecklistReport} />
                                <Route exact path="/reports/monthly" component={MonthlyReports} />
                                <AuthRoute
                                        exact
                                        path="/reports/monthly/:id" component={MDetails} />
                                <Route
                                        exact
                                        path="/reports/quarterly" component={QuarterlyReports} />
                                <AuthRoute
                                        exact
                                        path="/reports/quarterly/:id" component={QDetails} />
                        </Switch>
                </HashRouter>
        </Provider>,
        document.getElementById('argos') as HTMLElement
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx